module.exports = __webpack_public_path__ + "img/download.20315561.svg";